import  {type ThemeDefinition} from 'vuetify'

const defaultTheme: ThemeDefinition = {
    dark: false,
    colors: {
        // // primary: '#00DD87',
        secondary: '#0859D3',
        gray:  '#F5F5F5' ,

    },
    variables: {}
}

export default defaultTheme